export enum DeliveryMethod {
  Shipping = "SHIPPING",
  Pickup = "PICKUP",
  Unspecified = ""
}
